@use 'styles/functions/rem' as *;
@use 'styles/colors' as *;

.highlight {
    border-bottom: rem(5px) solid $highlightTabActiveColor;
    transition: 0.25s ease-out;
    width: 100%;
}
